import testimg from './testimg.png';
import access_denied from './access_denied.png';

export const IMAGES = { testimg, access_denied };
